var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRequiredMark = function SvgRequiredMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.865,
    cy: 11.865,
    r: 11.865,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.03 11.944 2.615 1.416-1.176 1.968-2.64-1.56.048 2.904h-2.256l.024-2.928-2.64 1.584-1.152-1.968 2.616-1.416-2.616-1.44 1.152-1.968 2.64 1.584-.024-2.928h2.256l-.048 2.928 2.64-1.584 1.176 1.968-2.616 1.44z",
    fill: "rgb(255, 255, 255)"
  })));
};
export default SvgRequiredMark;